import { useEffect, useRef } from "react";

interface AnimatedBackgroundProps {
  className?: string;
  children?: React.ReactNode;
}

export const AnimatedBackground = ({ className = "", children }: AnimatedBackgroundProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const mousePositionRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMouseMove = (e: MouseEvent) => {
      const rect = container.getBoundingClientRect();
      mousePositionRef.current = {
        x: (e.clientX - rect.left) / rect.width,
        y: (e.clientY - rect.top) / rect.height,
      };

      // Update CSS custom properties for the mouse position
      container.style.setProperty('--mouse-x', mousePositionRef.current.x.toString());
      container.style.setProperty('--mouse-y', mousePositionRef.current.y.toString());
    };

    container.addEventListener('mousemove', handleMouseMove);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div 
      ref={containerRef}
      className={`animated-gradient-bg ${className}`}
      style={{
        '--mouse-x': '0.5',
        '--mouse-y': '0.5',
      } as React.CSSProperties}
    >
      <div className="gradient-orb gradient-orb-1" />
      <div className="gradient-orb gradient-orb-2" />
      <div className="gradient-orb gradient-orb-3" />
      {children}
    </div>
  );
};